<template>
    <div>
        <v-card v-if="!editTeacher">
        <v-card-text>
            <ul class="list-info">
                <li class="mr-10">{{ $t('fields.name') }}</li>
                <li><b>{{ teacher.surname }} {{ teacher.name }}</b></li>
                <li>
                    <v-btn
                        x-small
                        text
                        class="primary"
                        v-if="teacher.options.notice_visible"
                        @click="showModalMessage(teacher.options.notice_visible)"
                    >
                        {{ $t('fields.notice_visible') }}
                    </v-btn>
                </li>
                <li>
                    <v-btn
                        x-small
                        text
                        class="primary"
                        v-if="teacher.options.notice_invisible"
                        @click="showModalMessage(teacher.options.notice_invisible)"
                    >
                        {{ $t('fields.notice_invisible') }}
                    </v-btn>
                </li>
                <li>{{ $t('fields.privacy') }}</li>
                <li>
                    <v-icon v-if="teacher.options.privacy" color="success">done</v-icon>
                    <v-icon v-else color="error">clear</v-icon>
                </li>

            </ul>
            <ul class="list-info" v-if="teacher.default_subject_name">
                <li class="mr-7">{{ $t('fields.subject')}}</li>
                <li><b>{{ teacher.default_subject_name }}</b></li>
            </ul>
            <ul class="list-info">
            <li class="mr-6">{{ $t('fields.address') }}</li>
            <li>
                <span
                    v-for="item in teacher.addresses" :key="item.id"
                >
                  <span v-if="item.street || item.city_name">
                    {{ item.street }} {{item.city_name}}
                  </span>
                  <span v-if="item.phone" >
                    <v-icon>phone</v-icon><a :href="`tel:${item.phone}`">{{ item.phone }}</a>
                  </span>
                  <span v-if="item.email" >
                    <v-icon>email</v-icon><a :href="`mailto:${item.email}`">{{ item.email.toLowerCase() }}</a>
                  </span>
                </span>
                <span v-if="teacher.options.alternative_email" >
                  <v-icon>email</v-icon>
                  <a :href="`mailto:${teacher.options.alternative_email}`">
                    {{ teacher.options.alternative_email.toLowerCase() }}
                  </a>
                </span>
                <span v-if="teacher.options.alternative_phone" >
                  <v-icon>phone</v-icon>
                  <a :href="`tel:${teacher.options.alternative_phone}`">
                    {{ teacher.options.alternative_phone }}
                  </a>
                </span>
            </li>
            </ul>
            <ul class="list-info">
            <li class="mr-6">{{ $t('fields.school') }}</li>
            <li v-bind:key="reloadAddress">
                <span
                    v-for="item in teacher.schools" :key="item.id"
                >
                  <p>
                    <b class="ml-1">{{ (item.options && item.options.branch_code) || item.code }}</b>
                    <b class="ml-1">{{ item.schools_types_code }} {{ item.school_name }}</b>
                    <span v-if="teacher.default_subject_name !== item.subject_name">
                      <b class="ml-1">- {{ item.subject_name }}</b>
                    </span>
                   <b class="ml-1">- {{( JSON.parse(item.pivot.options)) ? JSON.parse(item.pivot.options).classes : '' }}</b>

                    <span v-if="schoolsLocations[item.pivot.school_location_id]">
                        <span class="ml-2">{{ schoolsLocations[item.pivot.school_location_id].city }}</span>
                        <span class="ml-2">{{ schoolsLocations[item.pivot.school_location_id].postalcode }}</span>
                        <span class="ml-2"><a :href="`mailto:${schoolsLocations[item.pivot.school_location_id].email}`">
                          {{ schoolsLocations[item.pivot.school_location_id].email }}</a>
                        </span>
                        <span class="ml-2"><a :href="`tel:${schoolsLocations[item.pivot.school_location_id].phone}`">
                          {{ schoolsLocations[item.pivot.school_location_id].phone }}</a>
                        </span>
                        <span class="ml-2">{{ schoolsLocations[item.pivot.school_location_id].street }}</span>
                        <span class="ml-2"
                            v-for="propagandist in propagandistsLocations[item.pivot.school_location_id]" :key="propagandist.id"
                        >
                            {{ propagandist.fullname }}
                        </span>
                    </span>
                </p>
                </span>
            </li>
            </ul>
            <ul class="property-list ml-1">
                <li v-for="property in getPropertiesTeacher(teacher)" :key="property">

                  <span
                      v-if="teacher.options.properties[property] === true"
                    >
                        {{ getLabelProperty(property) }}:
                        <v-icon
                          color="success">
                          done
                        </v-icon>
                    </span>
                  <span v-else-if="
                    teacher.options.properties[property] === null ||
                     (typeof(teacher.options.properties[property]) === 'object'
                     && !Object.keys(teacher.options.properties[property]).length)" >
                  </span>

                  <span v-else-if="teacher.options.properties[property]">
                    {{ getLabelProperty(property) }}:<b>{{ teacher.options.properties[property] }}</b>
                  </span>
                </li>
            </ul>
        </v-card-text>
        <v-card-actions>
        <BtnAddEditTeacher
            class="primary"
            :id="teacher.id"
            @actionend="fetchTeacher(teacher.id)"
            :return-url="`${$router.currentRoute.path}?id=${teacher.id}`"
        >
            {{ $t('EDIT') }}
        </BtnAddEditTeacher>
        </v-card-actions>
    </v-card>
    <v-card v-else>
        <v-card-title>{{ teacher.surname }} {{ teacher.name }}</v-card-title>
        <v-card-text>
        <v-textarea
            v-model="propertySelected.options.notice_visible"
            :label="$t('fields.notice_visible')"
            :hint="$t('fields.notice_visible')"
        >
        </v-textarea>

        <v-textarea
            v-model="propertySelected.options.notice_invisible"
            :label="$t('fields.notice_invisible')"
            :hint="$t('fields.notice_invisible')"
        >
        </v-textarea>

        <TeacherContactOptions
            :prop-value="propertySelected.options.properties"
            @propertySelected="setProperty"
        />

        </v-card-text>
        <v-card-actions>
        <v-btn
            class="primary"
            @click="saveTeacher()"
        >
        {{ $t('SAVE') }}
        </v-btn>
        <v-btn
            @click="editTeacher=0"
        >
        {{ $t('CANCEL') }}
        </v-btn>
        </v-card-actions>
    </v-card>
    </div>
</template>
<script>
import { mapActions } from 'vuex';

import { teachersService } from '../../../utils/services/teachers.service';
import { TeacherContactTypes } from '../../../utils/constants/teacher-contact-constant';
import { schoolsLocationsService } from '../../../utils/services/schoolsLocations.service';
import BtnAddEditTeacher from '../../buttonsForms/BtnAddEditTeacher.vue';

import TeacherContactOptions from './TeacherContactOptions.vue';

export default {
    name: 'TeacherCommonInfo',
    components: {
        TeacherContactOptions,
        BtnAddEditTeacher,
    },
    props: {
        teacher: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            TeacherContactTypes,
            editTeacher: false,
            schoolsLocations: {},
            propagandistsLocations: {},
            reloadAddress: 0,
            propertySelected: {
                options: {
                    notice_visible: '',
                    notice_invisible: '',
                    properties: [],
                },
            },
        };
    },
    computed() {

    },
    methods: {
        ...mapActions('alert', ['showToast']),
        ...mapActions('modal', ['showModal', 'hideModal']),
        getLabelPlatform(label) {
            return this.getTeacherContacts()
                .filter(x => x.name === this.TeacherContactTypes.PLATFORM)[0]
                .items.filter(x => x.value === label)[0].label;
        },

        getLabelProperty(property) {
            return this.getTeacherContacts()
                .filter(x => x.name === property)[0].label;
        },

        showModalMessage(message) {
           this.showToast({ type: 'default', message });
        },

        setProperty(properties) {
            this.propertySelected.options.properties = properties;
        },

        getPropertiesTeacher(teacher) {
            return teacher.options.properties ? Object.keys(teacher.options.properties) : [];
        },

        async fetchTeacher(id) {
            return teachersService.get(id)
            .then(response => {
                this.teacher = response.data.data;
            })
            .catch(error => {
                this.handleError(error, this.errors);
            });
        },

        async fetchSchoolLocation(schoolId, schoolLocationId) {
            return schoolsLocationsService.get(schoolId, schoolLocationId)
                .then((response) => {
                    this.schoolsLocations[schoolLocationId] = response.data.data;
                    this.reloadAddress += 1;
                });
        },

        async fetchPropagandists(schoolId, schoolLocationId) {
            return schoolsLocationsService.propagandists(schoolId, schoolLocationId)
                .then((response) => {
                    this.propagandistsLocations[schoolLocationId] = response.data.data;
                    this.reloadAddress += 1;
                });
        },

        getLocationInfo(schoolLocationId) {
            return this.schoolsLocations[schoolLocationId];
        },

        async saveTeacher() {
        // const isValid = await this.$refs.formTeacher.validate();
        // if (isValid) {

          const teacher = {
              notice_visible: this.propertySelected.options.notice_visible,
              notice_invisible: this.propertySelected.options.notice_invisible,
              properties: this.propertySelected.options.properties,
          };

          teachersService.updateCommonInfo(this.teacher.id, teacher)
          .then(() => {
            this.showToast({ type: 'success', message: this.$t('SAVED') });
            this.fetchTeacher(this.teacher.id);
          })
          .catch(() => {
            this.showToast({ type: 'error', message: this.$t('UPDATE_ERROR') });
          })
          .finally(() => {
            this.editTeacher = 0;
          });


        // }
        // return false;
      },
    },

   async created() {
         this.teacher.schools.forEach(async (element) => {
             await this.fetchSchoolLocation(element.school_id, element.pivot.school_location_id);
             await this.fetchPropagandists(element.school_id, element.pivot.school_location_id);
         });
    },

    watch: {
      teacher: {
        immediate: true,
        deep: true,
        handler(val) {
         this.propertySelected.options = val.options;
        },
      },
    },
};
</script>
<style lang="scss" scoped>
    .list-info {
        display: flex;
        li {
            /*display: inline;*/
            list-style-type: none;
            padding-left: 10px;
        }
    }
</style>
